import { Location } from "@angular/common";
import { Component } from "@angular/core";
import { IonicPage } from "ionic-angular";
import { NavigationService } from "navigation/navigation.service";
import { BasePage } from "pages/base-page";
import { StateManagementService } from "providers/state-management/state-management.service";

@IonicPage({
  segment: "provider/eprescribe",
})
@Component({
  selector: "eprescribe",
  templateUrl: "eprescribe.html",
})
export class EPrescribePage extends BasePage {
  constructor(
    state: StateManagementService,
    public navSvc: NavigationService,
    private location: Location
  ) {
    super(state);
  }

  exit() {
    this.location.back();
  }
}



// WEBPACK FOOTER //
// ./src/pages/eprescribe/eprescribe.ts